import styled from 'styled-components'
import Loading from '../Loading'
import ResourceCard from '../Resources/ResourceCard'
import resources from '../Resources/resourcesData.json'
import useFetchPublicDetails from '../../helpers/hooks/useFetchPublicDetails'

const PageContainer = styled.main`
	margin: 2vh 2vw;
`
const CitySeparator = styled.div`
	margin-bottom: 24px;
	h1,
	h2,
	h3 {
		margin-bottom: 0;
		margin-right: 24px;
	}
	h2,
	h3 {
		// color: rgba(0, 0, 0, 0.7);
		font-weight: 600;
		font-size: 24px;
	}
	h3 {
		font-size: 16px;
	}
	hr {
		height: 1px;
		background-color: #979797;
		border: none;
	}
	.city-title {
		display: flex;
		align-items: baseline;
		h2 {
			text-transform: capitalize;
		}
	}
	.MuiSvgIcon-root {
		vertical-align: bottom;
	}
`
const ResourceCardContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
	grid-gap: 12px;
`

function getResourceCards(section, role) {
	return resources[section]
		.filter(({access}) => (access === 'all' ? true : access.includes(role)))
		.map(resource => <ResourceCard {...resource} key={resource.link} />)
}

function ResourceSection({role, section}) {
	const cards = getResourceCards(section, role)
	return (
		<>
			<CitySeparator>
				<div className="city-title">
					<h2>{section}</h2>
					<h3>
						{cards.length} file
						{cards.length !== 1 && 's'}
					</h3>
				</div>
				<hr />
			</CitySeparator>
			<ResourceCardContainer>{cards}</ResourceCardContainer>
		</>
	)
}

export default function ResourcesPage() {
	const {isSuccess, data} = useFetchPublicDetails()
	const role = data?.publicDetails?.role

	return (
		<PageContainer>
			{isSuccess ? (
				Object.keys(resources).map(section => (
					<ResourceSection
						role={role}
						section={section}
						key={section}
					/>
				))
			) : (
				<Loading />
			)}
		</PageContainer>
	)
}
